export enum Report {
  ProjectSummary = 2,
  ProjectCableSizing = 3,
  CablesList = 100,
  CableScheduleV1 = 101,
  PowerLoss = 102,
  CableSizing = 103,
  VoltageDropMatrix = 104,
  CableScheduleV2 = 105,
  MTOCables = 106,
  LoadList = 107,
  CableComments = 109,
  //UndefinedReport = 999
}
